import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DebitNoteService } from '../../../services/debit-note.service';
import { LoadingService } from '../../../services/loading.service';
import { ToastService } from '../../../services/toast.service';

@Component({
    selector: 'app-view-debit-note',
    templateUrl: './view-debit-note.component.html',
    styleUrls: ['./view-debit-note.component.scss']
})
export class ViewDebitNoteComponent implements OnInit {
    note: any = null;
    noteId: number = 0;
    isDownloadingPdf: boolean = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private debitNoteService: DebitNoteService,
        private loadingService: LoadingService,
        private toastService: ToastService
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            this.noteId = +params['id'];
            this.loadNoteData();
        });
    }

    private loadNoteData(): void {
        this.loadingService.show();
        this.debitNoteService.getById(this.noteId).subscribe({
            next: (response) => {
                this.note = response.data;
                this.loadingService.hide();
            },
            error: (err) => {
                console.error('Error loading note', err);
                this.toastService.showToast('error', 'Error al cargar la nota débito');
                this.loadingService.hide();
                this.router.navigate(['/debit-notes']);
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/debit-notes']);
    }

    downloadPdf(): void {
        this.isDownloadingPdf = true;
        
        this.debitNoteService.downloadPdf(this.noteId).subscribe({
            next: (blob) => {
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = `NotaDebito_${this.noteId}_${new Date().getTime()}.pdf`;
                link.click();
                window.URL.revokeObjectURL(url);
                this.isDownloadingPdf = false;
                this.toastService.showToast('success', 'PDF descargado correctamente');
            },
            error: (error) => {
                console.error('Error downloading PDF:', error);
                this.isDownloadingPdf = false;
                this.toastService.showToast('error', 'Error al descargar el PDF');
            }
        });
    }
}
